import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
  EventEmitter,
  Output,
  TemplateRef,
  ViewContainerRef,
  SimpleChanges,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RefreshGridService } from '../../../../../shared/services/refresh-grid.service'; // Import the shared service
import { RequestStatusEnum } from '../../../../../enums/requestStatusEnum';
import {
  GridModule,
  CellClickEvent,
  DataBindingDirective,
} from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { Border, ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import {
  KENDO_LAYOUT,
  LayoutModule,
  SelectEvent,
} from '@progress/kendo-angular-layout';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import {
  KENDO_ICONS,
  IconsModule,
  SVGIcon,
} from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS, ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { IntlModule } from '@progress/kendo-angular-intl';
import { PopupService, PopupRef } from '@progress/kendo-angular-popup'
import {
  starIcon,
  checkCircleIcon,
  envelopIcon,
  plusIcon,
  eyeIcon,
  minusIcon,
  starOutlineIcon,
  cancelCircleIcon,
  brightnessContrastIcon,
  searchIcon,
  playIcon,
} from '@progress/kendo-svg-icons';
import { process } from '@progress/kendo-data-query';


import { Input, ElementRef } from '@angular/core';
import { PopupModule, Align, AnimationDirection, AnimationType, PopupAnimation } from '@progress/kendo-angular-popup';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ShownotificationService } from '../../../../../services/shownotification.service';
import { ModulerequestService } from '../../../../../services/modulerequest.service';
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-request-module-activity-panel',
  standalone: true,
  imports: [
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_INDICATORS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    FormsModule,
    ReactiveFormsModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    NgxSpinnerModule
],
  templateUrl: './request-module-activity-panel.component.html',
  styleUrl: './request-module-activity-panel.component.scss'
})
export class RequestModuleActivityPanelComponent {
  @Input() openRequestModulePopup!: boolean;
  @Input() public moduleRequestDetail: any;
  @Input() public selectedRequestId: any;
  @Input() requestStatus!: string;
  @Input() anchor!: any;
  @Input() isApprovalUser: boolean = false;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() requestModuleButtonEvent = new EventEmitter<void>();
  public userProfile: any;

  isModuleApproveFlag = false;
  message: string = '';
  public isDisplayloader: boolean = false;

  @ViewChild('popupContent') popupContent!: TemplateRef<any>;

  //public requestEngagementRequestForm!: FormGroup;
  public requestModuleDetailsForm!: FormGroup;
  public selectedEngagementDetail: any;
  public selectedEngagementNumber: string = "";
  public searchedEngagementDetails: any[] = [];
  public RequestStatusEnum = RequestStatusEnum;

  private popupRef: PopupRef | undefined;

  //public form!: FormGroup;
  public enabled = true;
  public duration = 200;
  public type: AnimationType = "slide";
  public direction: AnimationDirection = "left";
  public margin = { horizontal: -30, vertical: -75 };

  public anchorAlign: Align = { horizontal: "right", vertical: "top" };
  public popupAlign: Align = { horizontal: "right", vertical: "top" };

  public get animate(): boolean | PopupAnimation {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }
    return false;
  }

  private readonly modulerequestService = inject(ModulerequestService);
  private readonly fb = inject(FormBuilder);
  private readonly shownotificationService = inject(ShownotificationService);
  private readonly refreshGridService = inject(RefreshGridService);
  private spinner = inject(NgxSpinnerService);

  ngOnChanges(changes: SimpleChanges) {
    this.spinner.show();
    if (changes['moduleRequestDetail']) {
    this.message="";
      if (this.requestStatus === RequestStatusEnum.Pending && !this.isApprovalUser) {
        this.message = 'Request is Pending';
      } else if (this.requestStatus === RequestStatusEnum.Approved && this.isApprovalUser) {
        this.message = 'Already Approved';
      } else if (this.requestStatus === RequestStatusEnum.Rejected) {
        this.message = 'Already Rejected';
      } else if (this.requestStatus === RequestStatusEnum.Completed) {
        this.message = 'Already Completed';
      }

      if (this.moduleRequestDetail) {
        this.setModuleRequestRequestFormValues();
        this.moduleRequestDetail.activityStream = [{ description: this.moduleRequestDetail.requestUserComment, date: new Date(this.moduleRequestDetail.requestedOn), title: this.moduleRequestDetail.requestUserDisplayName, subtitle: 'Requester' }];
         if (!(this.isApprovalUser && (this.requestStatus === RequestStatusEnum.Pending))) {
          this.moduleRequestDetail.activityStream.push({ description: this.moduleRequestDetail.approvalUserComment, date: new Date(this.moduleRequestDetail.approvedUserActionedOn), title: this.moduleRequestDetail.approvalUserDisplayName, subtitle: 'Approver' });
          if (this.requestStatus === RequestStatusEnum.Completed) {
            this.moduleRequestDetail.activityStream.push({ description: this.moduleRequestDetail.supportUserComment, date: new Date(this.moduleRequestDetail.completedOn), title: this.moduleRequestDetail.supportUserDisplayName, subtitle: 'Support User' });
          }
        }
      } else {
        this.isDisplayloader = true;
        this.spinner.show();
      }
    }
  }

  ngOnInit(): void {
    this.userProfile = JSON.parse(localStorage.getItem('userProfile') ?? "");
    this.createModuleRequestRequestForm();
    this.isDisplayloader = true;
    this.spinner.show();
    if (this.moduleRequestDetail) {
      this.setModuleRequestRequestFormValues();
    }
  }

  handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.close();
    }
  }


  resetForm(): void {
    //  this.name = '';
    //  this.accountId = '';
    //  if (this.form) {
    //    this.form.resetForm();
    //  }
  }

  public open(): void {
    this.openRequestModulePopup = true;
    this.resetModuleRequestRequestForm();

  }

  public close(): void {
    this.openRequestModulePopup = false;
    this.closeEvent.emit();
    this.resetModuleRequestRequestForm();

  }

  public onFilter(value: Event): void {
    const inputValue = value;
  }

  public createModuleRequestRequestForm(): void {
    this.requestModuleDetailsForm = this.fb.group({
      ModuleRequestId: [null, Validators.required],
      RequestId: [null, Validators.required],
      EngagementId: [null, Validators.required],
      ModuleId: [null, Validators.required],
      Name: [null],
      EngagementName: [null],
      Reason: [null],
      ApprovalUserId: [null],
      ApprovalUserEmail: [null],
      ApprovalUserComment: [null],
      SupportUserId: [null],
      SupportUserEmail: [null],
      SupportUserComment: [null],
    });
  }

  public resetModuleRequestRequestForm(): void {
    //  this.name = '';
    //  this.accountId = '';
    //  if (this.form) {
    //    this.form.resetForm();
    //  }
  }

  public setModuleRequestRequestFormValues() {
    if (this.moduleRequestDetail && this.requestModuleDetailsForm) {
      this.requestModuleDetailsForm.setValue({
        ModuleRequestId: this.moduleRequestDetail.moduleRequestId,
        RequestId: this.moduleRequestDetail.requestId,
        EngagementId: this.moduleRequestDetail.engagementId,
        ModuleId: this.moduleRequestDetail.moduleId,
        Name: this.moduleRequestDetail.name,
        EngagementName: this.moduleRequestDetail.engagementName,
        Reason: this.moduleRequestDetail.reason,
        ApprovalUserId: this.isApprovalUser ? this.userProfile.id : null,
        ApprovalUserEmail: this.isApprovalUser ? this.userProfile.email : this.moduleRequestDetail.approvalUserEmail,
        ApprovalUserComment: this.isApprovalUser ? "" : this.moduleRequestDetail.approvalUserComment,
        SupportUserId: !this.isApprovalUser ? this.userProfile.id : null,
        SupportUserEmail: !this.isApprovalUser ? this.userProfile.email : null,
        SupportUserComment: !this.isApprovalUser ? "" : null,
      })
      this.isDisplayloader = false;
      this.spinner.hide();
    }
  }

  public approveModuleRequest(): void {
    if (this.requestModuleDetailsForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      this.isModuleApproveFlag = true;
      this.modulerequestService.approveOrDenyModuleRequestDetails(this.requestModuleDetailsForm.value, this.selectedRequestId, this.isModuleApproveFlag).subscribe({
        next: (_) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.shownotificationService.showNotification('successModuleState');
          //this.requestModuleButtonEvent.emit();
          this.close();
          this.refreshGridService.refreshRequestGrid.next(true);
        },
        error: (x) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.close();
        }
      });

    }

  }

  public denyModuleRequest(): void {
    if (this.requestModuleDetailsForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      this.isModuleApproveFlag = false;
      this.modulerequestService.approveOrDenyModuleRequestDetails(this.requestModuleDetailsForm.value, this.selectedRequestId, this.isModuleApproveFlag).subscribe({
        next: (_) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.shownotificationService.showNotification('denyModuleState');
          //this.requestModuleButtonEvent.emit();
          this.close();
          this.refreshGridService.refreshRequestGrid.next(true);
        },
        error: (x) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.close();
        }
      });
    }

  }

  public addModuleRequest(): void {
    if (this.requestModuleDetailsForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      this.modulerequestService.AddModuleDetails(this.requestModuleDetailsForm.value, this.selectedRequestId).subscribe(
        {
          next: () => {
            this.shownotificationService.showNotification('successAddModuleState');
            //this.addModuleButtonEvent.emit();
            this.isDisplayloader = false;
            this.spinner.hide();
            this.refreshGridService.refreshRequestGrid.next(true);
            this.close();
          },
          error: (error) => {
            var errorResult = JSON.parse(error.error);
            if (errorResult.StatusCode == "500") {
              this.shownotificationService.showNotification(errorResult.StatusCode, errorResult.StatusCode + ":Internal Server Error")
            }
            else if (errorResult.StatusCode == "503") {
              this.shownotificationService.showNotification(errorResult.StatusCode, errorResult.StatusCode + ":Service Unavailable")
            }
            else {
              this.shownotificationService.showNotification("moduleRequestAlreadyExistError", errorResult.ErrorMessage);
            }
            this.isDisplayloader = false;
            this.spinner.hide();
            this.close();
          }
        });
    }
  }

  cancelModuleRequest(): void {
    this.close();
  }
}
